import React, { PropsWithChildren } from "react";

export const BlogLayout = ({ children }: PropsWithChildren) => {
  return (
    <div className="w-full px-4 laptop:mt-16">
      <div className="mx-auto max-w-screen-max">{children}</div>
    </div>
  );
};
